import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import React from 'react';
import AttributeContentSection from '../sections/AttributeContentSection';
import ShopifyProductsSection from '../sections/ShopifyProductsSection';
import phrasesType from '../proptypes/phrases';
import rankingType from '../proptypes/ranking';
import attributeContentPropTypes from '../proptypes/attribute-content';
import PageWrapper from '../design-system/PageWrapper';
import shopifyConfigType from '../proptypes/shopify-config';

const AttributeDetailPage = (props) => {
  const {
    attributeContent,
    attributesLinkText,
    attributesPath,
    shopifyConfig,
    shopifyCollection,
    phrases,
  } = props;

  return (
    <PageWrapper tallNav bgDark>
      <AttributeContentSection
        {...attributeContent}
        backLink={{
          text: attributesLinkText,
          path: attributesPath,
        }}
      />
      <ShopifyProductsSection
        count={6}
        title={phrases.giftsAndGadgetsTitle}
        config={shopifyConfig}
        collectionId={shopifyCollection}
        linkText={phrases.giftsAndGadgetsLink}
      />
    </PageWrapper>
  );
};

AttributeDetailPage.propTypes = {
  attributeId: PropTypes.string.isRequired,
  attributesPath: PropTypes.string.isRequired,
  attributesLinkText: PropTypes.string.isRequired,
  attributeContent: attributeContentPropTypes.isRequired,
  phrases: phrasesType.isRequired,
  ranking: rankingType.isRequired,
  shopifyConfig: shopifyConfigType.isRequired,
  shopifyCollection: PropTypes.string.isRequired,
};

export default hot(AttributeDetailPage);
